module.exports = __webpack_public_path__ + "img/hohlschnitt_reinweiss_ral9010.a58f9b4a.jpg";